import { Channels, Offices } from 'constants/enums'
import { Market } from 'services/shared/commercialStructure/interfaces'
import { useSelector } from 'store/store'

export const useCommercialStructure = () => {
  const { offices, regionals, zones } = useSelector((state) => state.shared)

  const getMarkets = () => {
    // TODO: Update this to use from redux when backend is ready
    const marketENUMS = Object.keys(Channels) as Channels[]

    const markets = marketENUMS.map((market) => ({
      id: market,
      description: market
    })) as Market[]

    return markets
  }

  const getOffices = () => {
    return offices
  }

  const getRegionals = () => {
    return regionals
  }

  const getZones = () => {
    return zones
  }

  const getOfficesByMarkets = (markets: Channels[]) => {
    const filteredOffices = offices.filter((office) => {
      return markets.includes(office.idMarket)
    })

    return filteredOffices
  }

  const getRegionalsByOffices = (offices: Offices[]) => {
    return regionals.filter((regional) => offices.includes(regional.idOffice as Offices))
  }

  const getZonesByRegionals = (regions: string[]) => {
    return zones.filter((zone) => regions.includes(zone.idRegional))
  }

  return {
    getMarkets,
    getOffices,
    getRegionals,
    getZones,
    getOfficesByMarkets,
    getRegionalsByOffices,
    getZonesByRegionals
  }
}
